const SPANISH_CODE = 'ES';

export default ({
  adminRepository,
}) => async (subdomain) => {
  const adminInfo = await adminRepository.getInfo(subdomain);
  adminInfo.isSpanishAdmin = adminInfo.countryCode === SPANISH_CODE;
  adminRepository.storeInfo({ ...adminInfo, subdomain });
};
